import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';
import TeacherTemplate from "../templates/TeacherTemplate";
import LottieLoader from "../loaders/LottieLoader";
import {translate} from "../../utils/Translate";

import AllDialogsExercisesPanel from "../dialogs/panels/AllDialogsExercisesPanel";
import AllQuestionnairesPanel from "../questionnaires/panels/AllQuestionnairesPanel";

export default function TeacherDialogsApp(props) {
    const [tab, setTab] = useState('my');

    return (
        <TeacherTemplate active={'questionnaires'}>

            <TopPlaceholder>
                <TopLeft>
                    {
                        [
                            {
                                label: translate('my_questionnaires'),
                                value: 'my'
                            },
                            {
                                label: translate('all_questionnaires'),
                                value: 'public'
                            },
                            {
                                label: 'Shared',
                                value: 'shared'
                            }
                        ].map((x, i) => {
                            return (
                                <TopRightTabItem selected={(x.value == tab)} key={i} onClick={() => {
                                    setTab(x.value);
                                }}>
                                    {x.label}
                                </TopRightTabItem>
                            )
                        })
                    }
                </TopLeft>
                <TopRight>

                </TopRight>
            </TopPlaceholder>

            <Wrapper key={tab}>

                <AllQuestionnairesPanel
                    mode={tab}
                />

            </Wrapper>


        </TeacherTemplate>
    );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  padding: 20px;
  
  @media (max-width: 720px) {
    height: 95vh;
    overflow-y: auto;
  }
`;

const TabsPlaceholder = styled.div`
  box-sizing: border-box;
  //padding: 15px;
`;


const TopPlaceholder = styled.div`
  background: white;
  height: 70px;
  //margin-bottom: 30px;
  box-sizing: border-box;
  padding-left: ${props => (props.hasLogo ? 0 : 15)}px;
  padding-right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TopLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 1200px) {
    font-size: 12px;
  }
`;

const TopRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ConstructionPlaceholder = styled.div`
  height: 80vh;
  text-align: center;
`;

const TopRightTabItem = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${props => (props.selected == true ? '#085BFF' : 'black')};
  cursor: ${props => (props.selected == true ? 'default' : 'pointer')};
  font-weight: ${props => (props.selected == true ? 'bold' : 'normal')};
  border-bottom: 6px solid ${props => (props.selected == true ? '#FFA71B' : 'white')};
  border-top: 6px solid white;
  box-sizing: border-box;
  height: 70px;

  @media (max-width: 1200px) {
    font-size: 12px;
    margin-left: 10px;
    margin-right: 10px;
  }

  :last-of-type {

  }

  :hover {
    color: #085BFF;
  }
`;